<template lang="pug">
  .list-business-documents.table-view
    .table-view-header
      h3 {{business.name}}
        span.text-capitalize , {{ [date, "DD-MM-YYYY"] | moment('MMMM YYYY') }}
        span(v-if="isFolder") , {{ businessFolder ? businessFolder.folder.name : '' }}
      .table-view-actions
        BaseDateSelect(v-model="date" :max-date="getCurrentPeriod()")
        b-btn.boton(v-if="isFolder" @click="openFileUpload" variant="secondary") Subir Archivo
    hr.m-0
    .view-container.pb-3.mt-3
      ListFolder.mb-3(v-if="folders.length" :folders="folders")
      ListFile.mb-3(v-if="files.length" :files="files" @done="fetchData")
      FileUpload(v-if="isFolder" ref="file-upload" :businessFolderId="businessFolder ? businessFolder.id : null " @done="fetchData")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseDateSelect from '../common/BaseDateSelect'
import ListFolder from './BusinessFolders/ListFolder'
import FileUpload from './BusinessFolderFile/FileUpload'
import ListFile from './BusinessFolderFile/ListFile'

export default {
  components: {
    BaseDateSelect,
    ListFolder,
    FileUpload,
    ListFile
  },
  data () {
    return {
      date: this.getCurrentPeriod()
    }
  },
  methods: {
    ...mapActions(['getBusiness', 'getBusinessFolder', 'listBusinessFolder', 'createBusinessFolderFile']),
    getCurrentPeriod () {
      const date = this.$moment()
      if (date.date() < 25) {
        date.subtract(1, 'M')
      }
      return date.date(1).format('DD-MM-YYYY')
    },
    openFileUpload () {
      this.$refs['file-upload'].openInputFile()
    },
    fetchData () {
      const { businessId, folderId } = this.$route.params
      if (folderId) {
        this.getBusinessFolder({ businessId, folderId, year: this.year, month: this.month })
      } else {
        this.listBusinessFolder({ businessId, year: this.year, month: this.month })
      }
    },
  },
  computed: {
    ...mapGetters(['business', 'businessFolder', 'businessFolders']),
    folders () {
      if(this.$route.params.folderId){
        let folders = []
        if (this.businessFolder) {
          folders = this.businessFolder.folder.subfolders.reduce((acum, folder) => {
            if (folder.isActive) {
              acum.push(folder)
            }
            return acum
          }, [])
        }
        return folders
      }
      return this.businessFolders
    },
    files () {
      if(this.$route.params.folderId){
        return this.businessFolder ? this.businessFolder.files : []
      }
      return []
    },
    year() {
      return this.$moment(this.date, 'DD-MM-YYYY').year()
    },
    month() {
      return this.$moment(this.date, 'DD-MM-YYYY').month() + 1
    },
    isFolder () {
      return this.$route.params.folderId ? true : false
    }
  },
  watch: {
    $route () {
      this.fetchData()
    },
    date () {
      this.fetchData()
    }
  },
  created () {
    const { businessId, folderId } = this.$route.params
    this.getBusiness(businessId)
    if (folderId) {
      this.getBusinessFolder({ businessId, folderId, year: this.year, month: this.month })
    } else {
      this.listBusinessFolder({ businessId, year: this.year, month: this.month })
    }
  },
  beforeUpdate(){
    this.$emit('businessName',this.business.name)
  }
}
</script>

<style lang="scss" scoped>
.base-date-select {
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>